import React from 'react';
import { dataHooks } from '../../constants';
import InfoIcon from '../../../InfoIcon';
import { st, classes } from './InfoContentIcon.st.css.js';
const InfoContentIcon = ({ infoContent, infoTooltipProps, required, }) => {
    return infoContent ? (React.createElement(InfoIcon, { dataHook: dataHooks.infoIcon, className: st(classes.root, {
            required,
        }), content: infoContent, tooltipProps: infoTooltipProps, size: "small" })) : null;
};
export default InfoContentIcon;
//# sourceMappingURL=InfoContentIcon.js.map